/** @jsxImportSource @emotion/react */
import React, { BaseSyntheticEvent, FormEventHandler, useEffect, useMemo, useState } from 'react';
import { locationsSearchStyles } from './locations-search.styles';
import FormInput from '../input/input.component';
import { IconSearch } from '../../assets/icons/icon-search';
import { useIntl } from 'react-intl';
import debounce from 'lodash.debounce';
import { useLocations } from '../../hooks/useLocations';
import { StringParam, useQueryParams } from 'use-query-params';

const LocationsSearch = () => {
    const intl = useIntl();
    const { setLocationsFilterSearch } = useLocations();
    const [searchValue, setSearchValue] = useState('');

    const [query, setQuery] = useQueryParams({
        search: StringParam,
    });

    const changeSearchHandler = (event: BaseSyntheticEvent) => {
        const value = event.target.value;
        setLocationsFilterSearch(value);
        setQuery({ search: value });
    };

    const debouncedChangeHandler = useMemo<FormEventHandler<HTMLInputElement>>(
        () => debounce(changeSearchHandler, 500),
        []
    );

    useEffect(() => {
        if (query.search) {
            setSearchValue(query.search);
        }
    }, [query.search]);

    return (
        <div css={locationsSearchStyles.inputWrapper}>
            <FormInput
                name={'search'}
                icon={<IconSearch size={16} color="#004FC6" />}
                placeholder={intl.formatMessage({ id: 'search.placeholder' })}
                value={searchValue}
                onChange={event => {
                    setSearchValue(event?.target?.value);
                    debouncedChangeHandler(event);
                }}
                showClearIcon
            />
        </div>
    );
};

export default LocationsSearch;
